import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import app from './app';
import chat from './chat/';

const reducers = { app, form, chat };
const combined = combineReducers(reducers);
module.exports = combined;



// WEBPACK FOOTER //
// ./reducers/index.js